import { defineStore } from 'pinia';
import PackageManagementService from '@/service/PackageManagementService';

export const usePackageManagementStore = defineStore('packageManagementStore', {
  state: () => ({
    gateways: [],
    destinations: []
  }),

  getters: {
    getUrlUploadFileFlight: () => {
      const Service = new PackageManagementService();
      return Service.getUrlPreviewFlightRule();
    },
    getUrlUploadFileGateway: () => {
      const Service = new PackageManagementService();
      return Service.getUrlUploadFileGateway();
    },
    getUrlUploadFileDestination: () => {
      const Service = new PackageManagementService();
      return Service.getUrlPreviewDestination();
    },
    getUrlUploadGatewayDuration: () => {
      const Service = new PackageManagementService();
      return Service.getUrlUploadGatewayDuration();
    }
  },

  actions: {
    async getListGateway() {
      const Service = new PackageManagementService();
      const res = await Service.getListGateway();
      this.gateways = res.data;
      return res.data;
    },

    async updateGatewayStatus(payload) {
      const Service = new PackageManagementService();
      const res = await Service.updateGatewayStatus(payload);
      return res.data;
    },

    async addEditGateway(payload) {
      const Service = new PackageManagementService();
      const res = await Service.addEditGateway(payload);
      return res.data;
    },

    async deleteEGateway(payload) {
      const Service = new PackageManagementService();
      const res = await Service.deleteEGateway(payload);
      return res.data;
    },

    async getListDestination() {
      const Service = new PackageManagementService();
      const res = await Service.getListDestination();
      this.destinations = res.data;
      return res.data;
    },

    async updateDestinationStatus(payload) {
      const Service = new PackageManagementService();
      const res = await Service.updateDestinationStatus(payload);
      return res.data;
    },

    async deleteDestination(payload) {
      const Service = new PackageManagementService();
      const res = await Service.deleteDestination(payload);
      return res.data;
    },

    async addEditDestinationStatus(payload) {
      const Service = new PackageManagementService();
      const res = await Service.addEditDestinationStatus(payload);
      return res.data;
    },

    getListInstaquoteRule() {
      const Service = new PackageManagementService();
      return Service.getListInstaquoteRule();
    },

    getDetailInstaquoteRule(sk) {
      const Service = new PackageManagementService();
      return Service.getDetailInstaquoteRule(sk);
    },

    addInstaquoteRule(payload) {
      const Service = new PackageManagementService();
      return Service.addInstaquoteRule(payload);
    },

    updateInstaquoteRuleStatus(sk, status) {
      const Service = new PackageManagementService();
      return Service.updateInstaquoteRuleStatus(sk, status);
    },

    deleteInstaquoteRule(sk) {
      const Service = new PackageManagementService();
      return Service.deleteInstaquoteRuleStatus(sk);
    },

    getOverlapDepature(params) {
      const Service = new PackageManagementService();
      return Service.getOverlapDepature(params);
    },

    getPricingQuote(id, body) {
      const Service = new PackageManagementService();
      return Service.getPricingQuote(id, body);
    },

    getHcmsPromotion(id, body) {
      const Service = new PackageManagementService();
      return Service.getHcmsPromotion(id, body);
    },

    getListDestinationGroup() {
      const Service = new PackageManagementService();
      return Service.getListDestinationGroup();
    },

    updateDestinationGroupStatus(sk, status) {
      const Service = new PackageManagementService();
      return Service.updateDestinationGroupStatus(sk, status);
    },

    deleteDestinationGroup(sk) {
      const Service = new PackageManagementService();
      return Service.deleteDestinationGroup(sk);
    },

    updateDestination(payload) {
      const Service = new PackageManagementService();
      return Service.updateDestination(payload);
    },

    getListGatewayDuration() {
      const Service = new PackageManagementService();
      return Service.getListGatewayDuration();
    },

    addGatewayDuration(payload) {
      const Service = new PackageManagementService();
      return Service.addGatewayDuration(payload);
    },

    updateGatewayDuration(payload) {
      const Service = new PackageManagementService();
      return Service.updateGatewayDuration(payload);
    },

    deleteGatewayDuration(id) {
      const Service = new PackageManagementService();
      return Service.deleteGatewayDuration(id);
    },

    updateStatusDuration(id, status) {
      const Service = new PackageManagementService();
      return Service.updateStatusDuration(id, status);
    },

    importFileFlightRule(payload) {
      const Service = new PackageManagementService();
      return Service.importFileFlightRule(payload);
    },

    importFileGateway(payload) {
      const Service = new PackageManagementService();
      return Service.importFileGateway(payload);
    },

    importFileDestination(payload) {
      const Service = new PackageManagementService();
      return Service.importFileDestination(payload);
    },

    getVersionRevert(type) {
      const Service = new PackageManagementService();
      return Service.getVersionRevert(type);
    },

    revertVersion(fileName) {
      const Service = new PackageManagementService();
      return Service.revertVersion(fileName);
    },

    getPreviewByFileName(fileName) {
      const Service = new PackageManagementService();
      return Service.getPreviewByFileName(fileName);
    },

    postSearchAdditional(payload) {
      const Service = new PackageManagementService();
      return Service.postSearchAdditional(payload);
    },

    getArdTaxSearchAdditional(gateway: string, destination: string, duration: number) {
      const Service = new PackageManagementService();
      return Service.getArdTaxSearchAdditional(gateway, destination, duration);
    },

    async getSeasonalRules() {
      const Service = new PackageManagementService();
      const res = await Service.getSeasonalRules();
      return res.data;
    },

    async editSeasonalRules(payload) {
      const Service = new PackageManagementService();
      const res = await Service.editSeasonalRules(payload);
      return res.data;
    },

    async getDetailSeasonalByType(type) {
      const Service = new PackageManagementService();
      const res = await Service.getDetailSeasonalByType(type);
      return res.data;
    },

    getPreviewDestinationByFileName(fileName) {
      const Service = new PackageManagementService();
      return Service.getPreviewDestinationByFileName(fileName);
    },

    revertVersionDestination(fileName) {
      const Service = new PackageManagementService();
      return Service.revertVersionDestination(fileName);
    },

    getPreviewGatewayByFileName(fileName) {
      const Service = new PackageManagementService();
      return Service.getPreviewGatewayByFileName(fileName);
    },

    revertVersionGateway(fileName) {
      const Service = new PackageManagementService();
      return Service.revertVersionGateway(fileName);
    },

    importGatewayDuration(payload) {
      const Service = new PackageManagementService();
      return Service.importGatewayDuration(payload);
    },

    getPreviewGatewayDuration(fileName) {
      const Service = new PackageManagementService();
      return Service.getPreviewGatewayDuration(fileName);
    },

    revertGatewayDuration(payload) {
      const Service = new PackageManagementService();
      return Service.revertGatewayDuration(payload);
    },

    updateCostRuleStatus(sk, status) {
      const Service = new PackageManagementService();
      return Service.updateCostRuleStatus(sk, status);
    },

    updateRuleConnectorStatus(sk: string, status: boolean) {
      const Service = new PackageManagementService();
      return Service.updateRuleConnectorStatus(sk, status);
    },

    getQuoteAdjusmentInfo(id, option) {
      const Service = new PackageManagementService();
      return Service.getQuoteAdjusmentInfo(id, option);
    },

    saveQuoteAdjusmentInfo(id, option, payload) {
      const Service = new PackageManagementService();
      return Service.saveQuoteAdjusmentInfo(id, option, payload);
    },

    deleteQuoteAdjusmentInfo(id, option) {
      const Service = new PackageManagementService();
      return Service.deleteQuoteAdjusmentInfo(id, option);
    },

    getPricingTour(id: string, payload: any) {
      const Service = new PackageManagementService();
      return Service.getPricingTour(id, payload);
    },

    getCheckingQuoteIds(ids: string) {
      const Service = new PackageManagementService();
      return Service.getCheckingQuoteIds(ids);
    }
  }
});
